
import {
  ApiManager,
  sessionService,
  ClientType,
  DocumentUtility
} from '../components/ComponentsLibrary';



const getMessageContent = async (messageContentID) => {
    const loginUserInfo = sessionService.getUser();
    const params = {
        stateID: loginUserInfo?.stateID,
        messageContentID,
    };

    const messageContentData = await ApiManager.GetMessageContentFromApi(params);
    return messageContentData
}

const addNextYearHoliday = (today, dateNY) => {
    const monthDiff = dateNY.getMonth() - today.getMonth();
    if (monthDiff > 0) return false;
    if (monthDiff < 0) return true;
    return (dateNY.getDate() <= today.getDate())
  }

const getHolidayList = async (today, siteID) => {
  const holidays = await ApiManager.getHolidayList({ siteID })
  let updatedHolidays = [];
  for (const holiday of holidays){
    const date = new Date(holiday?.currentDate)
    updatedHolidays.push(new Date(date.getFullYear(),
      date.getMonth(),
      date.getDate()))
    let dateNY = new Date(holiday?.nextDate)
    dateNY = addNextYearHoliday(today, dateNY) ? dateNY : null;
    if (dateNY) {
      updatedHolidays.push(new Date(dateNY.getFullYear(),
      dateNY.getMonth(),
      dateNY.getDate()))
    }
  }
  return updatedHolidays
}

const handleCopyPathButtonPress = async (selectedDoc, uncDocumentUrl, settingDetails, userDetails, masterServerDBSchema) => {
     
  try {
    
    const { stateID, siteID, userID } = userDetails;
    
    const tempDir = settingDetails?.settingDetailsApiData.find(
    value => parseInt(value.settingsDetailID) === ClientType.SettingsDetail.DMS_Scanning__Copy_Link_Temp_Path)?.settingsDetailValue;//TODo if temp path empty?
    if (!tempDir) {
      throw new Error("Temp Dir path not found")
    }
    const path = selectedDoc?.documentUNCPath || selectedDoc?.DocumentUNCPath;
    if (!path) {
      throw new Error("Document UNC path not found")
    }
    const documentName = path?.split("\\").pop();
    if (!documentName) {
      throw new Error("Document Name empty");
    };
    // Create temp file path
    const tempFilePath = `${tempDir}\\${String(userID)}_${String(selectedDoc?.batchID || selectedDoc?.BatchID)}_${documentName}`;
    console.log("Temp file path", tempFilePath)
    // Fetch the document contents and copy to to the temp file
    const docResponse = await fetch(uncDocumentUrl);
    if (!docResponse.ok) {
      throw new Error(`Failed to fetch document: ${docResponse.status}`);
    }
    const blobData = await docResponse.blob()
    await DocumentUtility.SaveFileToPhysicalPath(blobData, tempFilePath)
    await navigator.clipboard.writeText(tempFilePath);
    // Export Doc entry
    const docIDFilename = (String(selectedDoc?.batchDocumentID || selectedDoc?.BatchDocumentID) || "unknown") + "|" + documentName;
    const paramsExportDoc = {
      yTracSiteID: siteID,
      userLoginID: userID,
      stateSiteID: stateID,
      caseNumber: (selectedDoc?.caseNumber || selectedDoc?.CaseNumber) || "",
      emailList: "n/a",
      emailBody: "n/a",
      docExportMethodTypeID: ClientType.DocExportMethodType.Copy_Link,
      docIDFileNameList: docIDFilename,
      masterServerDBSchema
    };
    await ApiManager.ExportDocLog(paramsExportDoc)
  }
  catch (err) {
    console.error("error occured while copying file path to clipboard", err)
  }
}


const SharedService = {
    getMessageContent,
    getHolidayList,
    handleCopyPathButtonPress
}

export default SharedService;